export const initializePalette = (): ColorPalette => {
  return {
    Blue: generateColorPalette('#0075FF', 10),
    Red: generateColorPalette('#F90707', 10),
    Green: generateColorPalette('#5BCC33', 10),
    Yellow: generateColorPalette('#FCE61F', 10),
    Orange: generateColorPalette('#FFB800', 10),
    Purple: generateColorPalette('#AB69B1', 10),
    Pink: generateColorPalette('#E331E7', 10),
    Mix: generateMixedColorPalette('white', '#e74c3c', 10),
  };
};

function hexToRGB(hex: string): [number, number, number] {
  const rgb = parseInt(hex.slice(1), 16);
  const r = (rgb >> 16) & 255;
  const g = (rgb >> 8) & 255;
  const b = rgb & 255;
  return [r, g, b];
}

function RGBToHex(r: number, g: number, b: number): string {
  const rgb = (r << 16) | (g << 8) | b;
  return '#' + (0x1000000 + rgb).toString(16).slice(1);
}

function adjustBrightness(color: string, amount: number): string {
  const [r, g, b] = hexToRGB(color);
  const newR = Math.max(Math.min(r + amount, 255), 0);
  const newG = Math.max(Math.min(g + amount, 255), 0);
  const newB = Math.max(Math.min(b + amount, 255), 0);
  return RGBToHex(newR, newG, newB);
}

export function generateColorPalette(mainColor: string, numColors: number = 10): string[] {
  const palette: string[] = [];
  const step = Math.floor(255 / (numColors + 1));

  for (let i = 1; i <= numColors; i++) {
    const brightnessAdjustment = i * step * 1.1 - Math.floor(255 / 2.5);
    const newColor = adjustBrightness(mainColor, brightnessAdjustment);
    palette.push(newColor);
  }

  return palette;
}

function blendColors(color1: string, color2: string, ratio: number): string {
  const [r1, g1, b1] = hexToRGB(color1);
  const [r2, g2, b2] = hexToRGB(color2);
  const newR = Math.round(r1 * (1 - ratio) + r2 * ratio);
  const newG = Math.round(g1 * (1 - ratio) + g2 * ratio);
  const newB = Math.round(b1 * (1 - ratio) + b2 * ratio);
  return RGBToHex(newR, newG, newB);
}

export function generateMixedColorPalette(color1: string, color2: string, numColors: number = 5): string[] {
  const palette: string[] = [];
  for (let i = 0; i < numColors; i++) {
    const ratio = i / (numColors - 1);
    const blendedColor = blendColors(color1, color2, ratio * 1.05);
    palette.push(blendedColor);
  }
  return palette;
}

export type PaletteOptions = 'Blue' | 'Red' | 'Green' | 'Yellow' | 'Orange' | 'Purple' | 'Pink' | 'Mix';
export type ColorPalette = Record<PaletteOptions, string[]>;
